<section [formGroup]="loan.form" fxLayout="column" fxLayoutGap="8px">
  <mat-form-field>
    <mat-select placeholder="Who is your comaker?" required formControlName="comaker_relation">
      <ng-container *ngFor="let coMakerRelation of coMakerRelations">
        <mat-option *ngIf="coMakerRelation !== 'Relative'" [value]="coMakerRelation">
          {{ coMakerRelation }}
        </mat-option>
      </ng-container>
    </mat-select>
    <mat-error *ngIf="loan.form.get('comaker_relation').hasError('required')">Required.</mat-error>
  </mat-form-field>

  <mat-form-field>
    <input matInput placeholder="Comaker's name" required formControlName="comaker_name">
    <mat-error *ngIf="loan.form.get('comaker_name').hasError('required')">Required.</mat-error>
  </mat-form-field>

  <mat-form-field>
    <input matInput required formControlName="comaker_mobile_number" placeholder="Comaker's mobile number"/>
    <mat-error *ngIf="loan.form.get('comaker_mobile_number').hasError('invalid')">
      {{loan.form.get('comaker_mobile_number').getError('invalid')}}
    </mat-error>
    <mat-error *ngIf="loan.form.get('comaker_mobile_number').hasError('required')">Required.
    </mat-error>
  </mat-form-field>
</section>
